  import React, { useState, useEffect, useRef, useContext } from 'react';
  import SearchIcon from '@mui/icons-material/Search';
  import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
  import BoltIcon from '@mui/icons-material/Bolt'; // Icon for points
import Localbase from "localbase";
import { useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import ENDPOINT from "../data/ENDPOINT";
  // ---------------------------------------------------------------------------------------
  // Component for Top 3 (Podium Cards) - Elegant, light theme
  // ---------------------------------------------------------------------------------------
  const ElegantPodiumCard = ({ student, isFirst,rank }) => {
   
      
      // Muted pastel card background colors
      const colors = {
          1: { gradient: 'linear-gradient(145deg, #FFEFBA, #FFD700)', rankColor: '#B8860B', size: '96px', rankFontSize: '4rem', shadow: 'rgba(212, 175, 55, 0.5)' }, // Gold
          2: { gradient: 'linear-gradient(145deg, #EFEFEF, #C0C0C0)', rankColor: '#778899', size: '86px', rankFontSize: '3rem', shadow: 'rgba(192, 192, 192, 0.4)' }, // Silver
          3: { gradient: 'linear-gradient(145deg, #F0E6D8, #CD7F32)', rankColor: '#8B4513', size: '76px', rankFontSize: '2.5rem', shadow: 'rgba(205, 127, 50, 0.3)' }, // Bronze
      };

      const style = colors[rank];
      const topMargin = isFirst ? '20px' : '40px';

      return (
          <div 
              className="text-center position-relative p-4 mx-2 rounded-3" 
              style={{ 
                display: 'flex',
               flexWrap: 'wrap',
                justifyContent: 'center',
                  borderRadius: '20px',
                width: "96px",
                  flex: '0 0 30%', 
                  minHeight: '260px',
                  background: style.gradient,
                  boxShadow: `0 0 15px ${style.shadow}, 0 5px 15px rgba(0, 0, 0, 0.1)`,
                  zIndex: isFirst ? 10 : rank === 2 ? 8 : 6,
                  transform: isFirst ? 'scale(1.1) translateY(-10px)' : 'scale(1)',
                  transition: 'all 0.3s ease-in-out',
                  marginTop: topMargin,
                  color: '#2C3E50' // Deep Navy text on light background
              }}
          >
              <div 
                  className="position-absolute" 
                  style={{ 
                      top: '-20px', 
                      left: '50%', 
                      transform: 'translateX(-50%)', 
                      color: style.rankColor, // Rank number uses the metal color
                      textShadow: `1px 1px 3px ${style.shadow}`,
                      fontSize: style.rankFontSize,
                      fontWeight: '700',
                      lineHeight: '1',
                    // Elegant serif for rank number
                                      }}
                                  >
                                      {rank}
                                  </div>

                                  <div className="mt-4 mb-2">
                                      <img
                                          src={student.profile_pic&&student.profile_pic}
                                          alt={student.first_name+" "+student.last_name}
                                          className="rounded-circle border border-4"
                                          style={{
                                              width: style.size,
                                              height: style.size,
                                              objectFit: 'cover',
                                              borderColor: '#2C3E50', // Dark border for contrast
                                              boxShadow: `0 0 10px ${style.shadow}`
                                          }}
                                      />
                                  </div>
                                  <h6 className="fw-bolder mb-0 mt-1" 
                                      style={{ 
                                          textShadow: 'none', 
                                          fontFamily: 'Playfair Display, serif',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          width: '100%'
                                      }}
                                  >{student.first_name+" "+student.last_name}</h6>
                                  <small className="d-block text-muted fw-bold mt-1">{student.marks} POINTS</small>
                                  <WorkspacePremiumIcon style={{ fontSize: '30px',
                                     color: style.rankColor
                                      }} className="" />
                              </div>
                          );
                      };


                      // ---------------------------------------------------------------------------------------
                      // Component for Other Leaderboard Entries - Clean, white card
                      // ---------------------------------------------------------------------------------------
                      // **Accepts a ref prop** to allow scrolling to the element
  const LightLeaderboardCard = ({ student, cardRef, rank }) => {
      const { name, points, level, avatar } = student;
      const isCurrentUser = student.current_user; 
      
      // Light aesthetic colors
      const textColor = '#2C3E50'; // Deep Navy
      const accentColor = '#D4AF37'; // Soft Gold
      const hoverBg = '#FFFDF5'; // Ivory on hover
      const borderColor = isCurrentUser ? accentColor : 'transparent';

      return (
          // **Apply the ref here**
          <div
              ref={cardRef} 
              className="list-group-item card border-0 p-3 mb-3 d-flex flex-row align-items-center"
              style={{
                  borderRadius: '16px',
                  background: '#FFFFFF', // Pure white card
                  border: `1px solid ${borderColor}`,
                  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)', // Subtle shadow
                  color: textColor,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease-in-out',
                  scrollMarginTop: '20px', // Ensures a little space above the element when scrolled to
              }}
              onMouseEnter={e => {
                  e.currentTarget.style.boxShadow = `0 6px 15px rgba(0, 0, 0, 0.1), 0 0 8px ${accentColor}33`;
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.style.backgroundColor = hoverBg;
              }}
              onMouseLeave={e => {
                  e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.05)';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.backgroundColor = '#FFFFFF';
              }}
          >
              {/* Rank - Accent color */}
              <div className="me-4 fw-light fs-3" 
              style={{ color: accentColor, width: '40px', textAlign: 'right', fontFamily: 'Playfair Display, serif' }}>
                  {String(rank).padStart(2, '0')}
              </div>
              {/* Avatar */}
              <div className="me-4">
                  <img
                      src={student.profile_pic&&student.profile_pic}
                      alt={student.first_name+" "+student.last_name}
                      className="rounded-circle"
                      style={{ width: '55px', height: '55px', objectFit: 'cover', border: `3px solid ${accentColor}` }}
                  />
              </div>
              {/* Name and Level */}
              <div className="flex-grow-1">
                  <h6 className="mb-0 fw-bold" style={{ color: textColor }}>{student.first_name+" "+student.last_name} {isCurrentUser && '(You)'}</h6>
                  <small className="text-muted">{rank} Level</small>
              </div>
              {/* Points and Icon */}
              <div className="d-flex align-items-center">
                  <div className="text-end me-3">
                      <div className="d-flex align-items-center justify-content-end">
                          <BoltIcon style={{ fontSize: '20px', color: '#1E90FF', marginRight: '5px' }} />
                          <span className="fw-bold" style={{ color: textColor }}>{student.marks}</span>
                      </div>
                  </div>
                  <WorkspacePremiumIcon style={{ fontSize: '36px', color: accentColor }} />
              </div>
          </div>
      );
  };


  // ---------------------------------------------------------------------------------------
  // Main App Component with Light Background and Subtle Animation
  // ---------------------------------------------------------------------------------------
  function HackingChallengeLeaderboard() {



      const params = useParams();
     
      const challenge_id = params.challenge_id; 
      const { user } = useContext(AuthContext);
      const [leaderboard, setLeaderboard] = useState([]);
      const [initialData, setInitialData] = useState([]);
      const [response, setResponse] = useState([]);
      const [searchTerm, setSearchTerm] = useState("");
    
      let db = new Localbase("db");
    
      const fetchLeaderboard = async () => {
        const formData = new FormData();
       
        formData.append("challenge_id", challenge_id);
        if(user && user.SessionId){
          formData.append("session", user.SessionId);
        }
       
        try {
          const res = await axios.post(ENDPOINT+"challenge-submission-leaderboard.php",formData, { 
            headers: { "Content-Type": "multipart/form-data" },
          });
          const data = res.data;
          if (data.status === "success" && data.leaderboard) {
            setLeaderboard(data.leaderboard);
            setInitialData(data.leaderboard.slice(3));
            setResponse(data.leaderboard.slice(3));
    
            await db.collection("paths").add(
              {
                challenge: data.leaderboard,
              },
              "leaderboard"
            );
          } else {
            console.error("Error fetching leaderboard:", data.message);
          }
        } catch (error) {
          console.error("Error fetching leaderboard:", error);
        }
      };
    
      useEffect(() => {
        // Check local storage first
        db.collection("paths")
          .doc("challenge-leaderboard")
          .get()
          .then((doc) => {
            if (doc && doc.leaderboard) {
              setLeaderboard(doc.leaderboard);
              setInitialData(doc.leaderboard);
              setResponse(doc.leaderboard);
            }
          })
          .catch((error) => {
            console.error("Error fetching data from Localbase", error);
          });
    
        // Fetch from API
        fetchLeaderboard();
      }, []);
    
   
    
      const [searchQuery, setSearchQuery] = useState('');
      // 1. Create a Ref for the current user's card
      const currentUserRef = useRef(null);



      const filteredStudents = Array.isArray(initialData) && initialData.length > 0&&initialData.filter((item) => {
      
        return (
          item.first_name&&item.first_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.last_name&&item.last_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.username&&item.username.toLowerCase().includes(searchQuery.toLowerCase())
        );
      });

       const handleSearch = (e) => {
    const rawValue = e.target.value;
    setSearchTerm(rawValue);

    const term = rawValue.toLowerCase();
    console.log(term);

    if (initialData) {
      const filteredData = initialData.filter((item) => {
        return (
         item.first_name&& item.first_name.toLowerCase().includes(term) ||
          item.last_name&&item.last_name.toLowerCase().includes(term) ||
          item.username&&item.username.toLowerCase().includes(term)
        );
      });
      setResponse(filteredData);
    }
  };

      const topThree =  Array.isArray(leaderboard) && leaderboard.length > 0&&leaderboard.slice(0, 3);
      const remaining =  Array.isArray(leaderboard) && leaderboard.length > 0&&leaderboard.slice(3);

     
      useEffect(() => {
          // Only scroll if the user is not in the search filter (i.e., we are showing the full list)
          if (currentUserRef.current && searchQuery === '') {
              currentUserRef.current.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center' // Scrolls to the center of the viewport
              });
          }
      }, [searchQuery]); 

     
      const fontStyles = {
          title: { fontFamily: 'Playfair Display, serif' },
          body: { fontFamily: 'Source Sans Pro, sans-serif' },
          accentColor: '#D4AF37' // Soft Gold
      };
      
      // Custom light background with subtle "animated" white color effect
      const lightAnimatedBackground = {
          // Base background is a very light gray
          background: '#F7F7F7',
          minHeight: '100vh',
          color: '#2C3E50', // Deep Navy text
          ...fontStyles.body,
          // Global smooth scroll for the whole page/container
          scrollBehavior: 'smooth', 
          // The "animation" is a subtle, recurring box-shadow that simulates a soft light pulse
          transition: 'box-shadow 4s ease-in-out infinite',
          boxShadow: '0 0 20px rgba(0, 0, 0, 0) inset'
      }

      const TopBar = () => (
          <div 
              className="w-100 d-flex justify-content-center py-5 px-3" 
           
          >
          
          </div>
      );
      
      // Custom keyframes style for the subtle animation (CSS-in-JS alternative for demonstration)
      const animationKeyframes = `
          @keyframes subtlePulse {
              0% { box-shadow: 0 0 20px rgba(212, 175, 55, 0.0) inset; }
              50% { box-shadow: 0 0 30px rgba(212, 175, 55, 0.1) inset; }
              100% { box-shadow: 0 0 20px rgba(212, 175, 55, 0.0) inset; }
          }
      `;
      
      // Apply the animation style
      if (typeof window !== 'undefined') {
        // Prevents adding the style sheet multiple times in development
                  if (!document.querySelector('#subtlePulseStyle')) {
                      const styleSheet = document.createElement("style");
                      styleSheet.id = "subtlePulseStyle";
                      styleSheet.type = "text/css";
                      styleSheet.innerText = animationKeyframes;
                      document.head.appendChild(styleSheet);
                  }
                  lightAnimatedBackground.animation = 'subtlePulse 8s ease-in-out infinite';
              }

              if (Array.isArray(leaderboard) && leaderboard.length === 0) {
                  return (
                    <div style={lightAnimatedBackground} className="d-flex align-items-center justify-content-center min-vh-100">
                      <div className="text-center">
                        <SearchIcon style={{ fontSize: '100px', color: '#D4AF37', opacity: 0.5 }} />
                        <h2 className="mt-4 mb-3" style={{ color: '#2C3E50' }}>No Data Found</h2>
                        <p className="text-muted">There are no leaderboard entries available at this time.</p>
                      </div>
                    </div>
                  )
              }

              return (
                  <div style={lightAnimatedBackground}>
                      <TopBar />

                      <div className=" py-4 py-lg-5">
                          <div className="row justify-content-center" style={{ maxWidth: '1400px', margin: '0 auto' }}>
                              
                           
                              <div className="col-12 col-lg-5 mb-5 mb-lg-0">
                                  {Array.isArray(topThree) &&topThree.length > 0 && (
                                      <div className="p-4 rounded-4" 
                                      style={{ backgroundColor: '#FFFFFF', border: '1px solid #EAEAEA', boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)' }}>
                                          <h2 className="text-center mb-4 pb-2 border-bottom" 
                                          style={{ ...fontStyles.title, color: '#2C3E50', borderColor: '#EAEAEA' }}>The Champions</h2>


                                          <div className="d-flex flex-md-row align-items-end justify-content-center">
                                              {/* Podium Cards are rendered here */}
                                      {topThree[1] && <ElegantPodiumCard student={topThree[1]} rank={2} isFirst={false}  />}
                                      {topThree[0] && <ElegantPodiumCard student={topThree[0]} rank={1} isFirst={true} />}
                                      {topThree[2] && <ElegantPodiumCard student={topThree[2]} rank={3} isFirst={false} />}
                                  </div>
                              </div>
                          )}
                      </div>

                      {/* RIGHT COLUMN: SEARCH AND REMAINING ENTRIES */}
                      <div className="col-12 col-lg-7">
                          <div className="p-4 rounded-4" style={{ backgroundColor: '#FFFFFF', border: '1px solid #EAEAEA', boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)' }}>
                              
                              {/* Search Bar */}
                              <div className="d-flex align-items-center justify-content-between mb-4 flex-column flex-sm-row gap-3">
                                  <h3 className="fw-bold mb-0" style={{ ...fontStyles.title, color: '#2C3E50' }}>All Members</h3>
                                  <div className="position-relative" style={{ width: '100%', maxWidth: '350px' }}>
                                      <SearchIcon
                                          className="position-absolute"
                                          style={{ left: '15px', top: '50%', transform: 'translateY(-50%)', fontSize: '24px', color: fontStyles.accentColor }}
                                      />
                                      <input
                                          type="text"
                                          className="form-control form-control-lg ps-5 rounded-pill border-0"
                                          placeholder="Search Name..."
                                          value={searchTerm}
                                          onChange={handleSearch}
                                          style={{ background: '#F7F7F7', color: '#2C3E50', border: `1px solid ${fontStyles.accentColor}55` }}
                                      />
                                  </div>
                              </div>

                              {/* Leaderboard Entries */}
                              <div className="list-group">
                                  {Array.isArray(response) &&response.map((student, index) => (
                                      <LightLeaderboardCard 
                                          key={student.id} 
                                          student={student} 
                                          rank={index + 4}
                                        
                                          cardRef={index === 3 ? currentUserRef : null}
                                      />
                                  ))}
                              </div>

                              {/* Empty State */}
                              {response.length === 0 && (
                                  <div className="text-center py-5">
                                      <SearchIcon style={{ fontSize: '80px', color: fontStyles.accentColor }} className="mb-3" />
                                      <h4 className="fw-bold mb-2" style={{ color: '#2C3E50' }}>No player found</h4>
                                      <p className="text-muted">Refine your search parameters.</p>
                                  </div>
                              )}
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      );
  }

  export default HackingChallengeLeaderboard;